import React from 'react';
import styled from 'styled-components';

import { QUERIES } from '../constants/mediaQueries';
import { HEADER_CTA_LINK, HEADER_NAV_LINKS } from '../constants/navigationLinks';
import Links from './Links';
import Button from './Button';
import LogoBanner from './LogoBanner';

const NavContainer = styled.section`
  position: relative;
  width: 100%;
  background-color: var(--color-neutral-white);
  display: none;
  min-height: var(--height-header);
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  justify-items: start;
  gap: var(--spacing-large);
  padding: 0 var(--spacing-xlarge);
  height: 100%;
  max-width: var(--container-large);
  margin: 0 auto;

  ${QUERIES.minLaptop} {
    display: grid;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  justify-self: start;
`;

const NavLinksSection = styled.div`
  display: flex;
  align-items: center;
  justify-self: center;
  width: 100%;
  justify-content: center;

  ul {
    display: flex;
    align-items: center;
    gap: var(--spacing-xlarge);
  }
`;

const CtaSection = styled.div`
  display: flex;
  align-items: center;
  justify-self: end;
`;

const DesktopNav: React.FC = () => {
  return (
    <NavContainer>
      <LogoSection>
        <LogoBanner />
      </LogoSection>
      <NavLinksSection>
        <Links links={HEADER_NAV_LINKS} gap="xlarge" />
      </NavLinksSection>
      <CtaSection>
        <Button variant="secondary" href={HEADER_CTA_LINK.to} ariaLabel={HEADER_CTA_LINK.ariaLabel}>
          {HEADER_CTA_LINK.label}
        </Button>
      </CtaSection>
    </NavContainer>
  );
};

export default DesktopNav;
